import styled from 'styled-components';

export default styled.div`
  width: 100%;

  &:not(&:last-child) {
    margin-bottom: 1em;
  }

  &__label {
    color: #97a3ba;
  }

  .input {
    width: 100%;
    background: #fcfcfd;
    border: 1px solid #d8dfed;
    box-sizing: border-box;
    border-radius: 2px;
    position: relative;
    transition: 0.1s;

    &:focus-within {
      border-color: @dark;
    }

    input {
      width: 100%;
      outline: none;
      border: none;
      height: 42px;

      &::placeholder {
        color: @dark-20;
      }
    }

    .dropdown {
      visibility: hidden;
      opacity: 0;
      z-index: -1;
      position: absolute;
      top: 100%;
      right: -1px;
      left: -1px;
      background: #ebebeb;
      border: 1px solid @dark;
      transition: 0.1s;
      transform: translateY(40px);
      border-radius: 0 0 2px 2px;

      &.active {
        visibility: visible;
        opacity: 1;
        z-index: 2;
        transform: translateY(0);
      }

      &__item {
        cursor: pointer;

        &:not(&:last-child) {
          border-bottom: 1px solid rgba(163, 174, 195, 0.47);
        }
      }
    }

    .icon-end,
    .icon-start {
      position: absolute;
      top: 50%;
    }

    .icon-start {
      transform: translateY(-50%);
      :not(.isRTL) {
        left: calc(1em - 4px);
      }
      &.isRTL {
        right: calc(1em - 4px);
      }
    }

    .icon-end {
      transform: translateY(-50%);
      :not(.isRTL) {
        right: calc(1em - 4px);
      }
      &.isRTL {
        left: calc(1em - 4px);
      }
    }
  }
`;
